import React, { Component } from "react";
import DateBadge from "../components/DateBadge";
import Parser from 'html-react-parser';

class Event extends Component {
	constructor(props) {
		super(props);

		let location = props.event.location ? "&location=" + props.event.location : "";

		let startDate = new Date(props.event.start.dateTime ? props.event.start.dateTime : props.event.start.date);
		let startYear = props.event.start.dateTime ? startDate.getYear() : startDate.getUTCFullYear();
		let startMonth = (1 + (props.event.start.dateTime ? startDate.getMonth() : startDate.getUTCMonth())).toString().padStart(2, "0");
		let startDayOfMonth = (props.event.start.dateTime ? startDate.getDate() : startDate.getUTCDate()).toString().padStart(2, "0");

		// TODO display times properly in the link ('T' + HHMMSS)
		let startTime = props.event.start.dateTime ? 'T' : '';

		let start = startYear + '' + startMonth + '' + startDayOfMonth + startTime;

		let endDate = new Date(props.event.end.dateTime ? props.event.end.dateTime : props.event.end.date);
		let endYear = props.event.end.dateTime ? endDate.getYear() : endDate.getUTCFullYear();
		let endMonth = (1 + (props.event.end.dateTime ? endDate.getMonth() : endDate.getUTCMonth())).toString().padStart(2, "0");
		let endDayOfMonth = (props.event.end.dateTime ? endDate.getDate() : endDate.getUTCDate()).toString().padStart(2, "0");

		// TODO display times properly in the link ('T' + HHMMSS)
		let endTime = props.event.end.dateTime ? 'T' : '';

		let end = endYear + '' + endMonth + '' + endDayOfMonth + endTime;

		this.state = {
			isPast: startDate < new Date(),
			summary: props.event.summary,
			description: props.event.description,
			attachments: props.event.attachments,
			start: props.event.start,
			link: 'http://www.google.com/calendar/event?action=TEMPLATE&dates=' + start + '/' + end + '&text=' + props.event.summary + location
		}
	}

	render() {
		let addToCalendar = this.state.isPast ? null : (
			<a className="nf-cal-btn" href={this.state.link} target="_blank" rel="noopener noreferrer">Add to calendar</a>
		);

		return (
			<article className="nf-entry">
				<div className="nf-entry-date">
					<DateBadge startDate={this.state.start} />
				</div>
				<div className="nf-entry-body">
					<h3 className="nf-entry-title">{Parser(this.state.summary)}</h3>
					<div className="nf-entry-desc site-text">{this.state.description ? Parser(this.state.description) : ""}</div>
					{this.state.attachments && this.state.attachments.length > 0 && (
						<div className="nf-entry-img">
							<img src={"https://drive.google.com/uc?export=view&id=" + this.state.attachments[0].fileId} alt={this.state.summary} />
						</div>
					)}
					{addToCalendar}
				</div>
			</article>
		);
	}
}

export default Event;
